export default __webpack_public_path__ + "static/img/retail-bp-back.bd9d084.jpg";